module.exports = __webpack_public_path__ + "static/6-e0ab56f6e2f1578f594337c373e4e045.png";